import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'TriSubLayout' },
  __name: 'TriSubLayout',
  setup(__props) {

// import { computed } from 'vue'
// import { useStore } from 'vuex'

// const store = useStore()
// const cachedViews = computed(() => store.state.app.cachedViews)


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
    ]),
    _: 1
  }))
}
}

})